const FOOTER_SERVICES = [
  'Landscape Design',
  'Hardscaping & Patios',
  'Outdoor Living Spaces',
  'Irrigation Systems',
  'Lawn Installation',
  'Lighting Systems',
];

const FOOTER_AREAS = [
  'Las Cruces, NM',
  'Alamogordo, NM',
  'El Paso, TX',
  'Ruidoso, NM',
  'Roswell, NM',
  'White Sands, NM',
];

export default function Footer() {
  return (
    <footer className="bg-charcoal-900 text-white border-t border-white/5">
      {/* Top CTA strip */}
      <div className="border-b border-white/8 bg-forest-600/20">
        <div className="max-w-7xl mx-auto px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-5">
          <div>
            <p className="font-serif text-white text-xl font-semibold">Ready to Transform Your Property?</p>
            <p className="font-sans text-stone-400 text-sm mt-0.5">Premium landscaping design &amp; construction — serving NM &amp; El Paso</p>
          </div>
          <div className="flex items-center gap-4 flex-shrink-0">
            <a
              href="tel:5756358883"
              className="inline-flex items-center gap-2 font-sans text-stone-300 hover:text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-stone-400" />
              </div>
              (575) 635-8883
            </a>
            <a
              href="#consultation"
              onClick={(e) => { e.preventDefault(); document.getElementById('consultation')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center gap-2 bg-forest-500 hover:bg-forest-400 text-white font-sans text-sm font-semibold px-6 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              Free Consultation
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Main footer grid */}
      <div className="max-w-7xl mx-auto px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-6">
            <img
              src="https://brainardsgreenscapes.com/assets/images/logo.png"
              alt="Brainard's Greenscapes"
              className="h-16 w-auto object-contain"
            />
          </div>
          <p className="font-sans text-stone-500 text-sm leading-relaxed mb-6">
            Premium landscape design and outdoor construction for discerning homeowners across southern New Mexico and El Paso. Serving the community for 19+ years.
          </p>
          {/* Review stars */}
          <div className="flex items-center gap-1.5 mb-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-gold-400 text-xs" />
              </div>
            ))}
            <span className="font-sans text-stone-400 text-xs ml-1">4.9 / 5.0</span>
          </div>
          <p className="font-sans text-stone-500 text-xs">35+ verified five-star reviews</p>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-sans text-stone-400 text-[10px] tracking-[0.2em] uppercase font-semibold mb-6">Our Services</h4>
          <ul className="space-y-3">
            {FOOTER_SERVICES.map((svc) => (
              <li key={svc}>
                <a
                  href="#services"
                  onClick={(e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="font-sans text-stone-500 text-sm hover:text-stone-300 transition-colors cursor-pointer"
                >
                  {svc}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Service Areas */}
        <div>
          <h4 className="font-sans text-stone-400 text-[10px] tracking-[0.2em] uppercase font-semibold mb-6">Service Areas</h4>
          <ul className="space-y-3">
            {FOOTER_AREAS.map((area) => (
              <li key={area}>
                <a
                  href="#service-areas"
                  onClick={(e) => { e.preventDefault(); document.getElementById('service-areas')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="font-sans text-stone-500 text-sm hover:text-stone-300 transition-colors cursor-pointer"
                >
                  {area}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-sans text-stone-400 text-[10px] tracking-[0.2em] uppercase font-semibold mb-6">Get In Touch</h4>
          <div className="space-y-4 mb-8">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-phone-line text-stone-500 text-base" />
              </div>
              <div>
                <div className="font-sans text-stone-500 text-xs mb-0.5">Phone</div>
                <a href="tel:5756358883" className="font-sans text-stone-300 text-sm hover:text-white transition-colors cursor-pointer">(575) 635-8883</a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-mail-line text-stone-500 text-base" />
              </div>
              <div>
                <div className="font-sans text-stone-500 text-xs mb-0.5">Email</div>
                <a href="mailto:greenscapeslc@yahoo.com" className="font-sans text-stone-300 text-sm hover:text-white transition-colors cursor-pointer">greenscapeslc@yahoo.com</a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-line text-stone-500 text-base" />
              </div>
              <div>
                <div className="font-sans text-stone-500 text-xs mb-0.5">Address</div>
                <div className="font-sans text-stone-300 text-sm">Las Cruces, NM 88011-4121</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-time-line text-stone-500 text-base" />
              </div>
              <div>
                <div className="font-sans text-stone-500 text-xs mb-0.5">Business Hours</div>
                <div className="font-sans text-stone-300 text-sm">Mon–Fri: 9:00AM–4:00PM<br />Sat &amp; Sun: Closed</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-bank-card-line text-stone-500 text-base" />
              </div>
              <div>
                <div className="font-sans text-stone-500 text-xs mb-0.5">Payment Methods</div>
                <div className="font-sans text-stone-300 text-sm">Zelle · Cash · Check</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-sans text-stone-600 text-xs">
            © 2026 Brainard's Greenscapes. All rights reserved. Fully Licensed &amp; Insured — Las Cruces, NM 88011-4121
          </p>
          <p className="font-sans text-stone-600 text-xs">
            Landscape Design · Hardscaping · Outdoor Living · Las Cruces, NM
          </p>
        </div>
      </div>
    </footer>
  );
}
